import { render, staticRenderFns } from "./FirstCheckinWelcome.vue?vue&type=template&id=bae4220c&"
import script from "./FirstCheckinWelcome.vue?vue&type=script&lang=js&"
export * from "./FirstCheckinWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports